/* eslint-disable react-hooks/exhaustive-deps */
import { LogisticaManifiestoProformaEstado } from "@pcgerente-node/pcg-comun";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import img1 from "../../../../assets/img/Recurso 3.png";
import { getManifiestoDetails } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import CodigoBarra from "../../../helpers/CodigoBarra/CoidgoBarra";
import Loading from "../../../helpers/Loading/Loading";
import GuiaIndv from "./GuiaIndv";


const ImprimirContent = () => {
  const StyleProps1: React.CSSProperties = {
    fontSize: "80%",
    lineHeight: "11px",
    textAlign: "left"
  }
  const StyleProps3: React.CSSProperties = {
    fontSize: "80%",
    width: "100%",
    lineHeight: "11px",
    textAlign: "left"
  }

  const StyleProps1_1: React.CSSProperties = {
    fontSize: "80%",
    lineHeight: "15px",
    textAlign: "center",
    marginLeft: "15px"
  }


  const dispatch = useAppDispatch()

  const { idManifiesto } = useParams()


  const manifiestoDB = useSelector((state: RootState) => state.crear.imprimirManifiestosProforma)


  useEffect(() => {
    if (idManifiesto)
      dispatch(getManifiestoDetails(Number(idManifiesto)))
  }, [idManifiesto])
  
  
  
  let mp = manifiestoDB.info[0]?.logistica_MANIFIESTO_PROFORMA
  return (
    manifiestoDB.info.length>0 ?
      <div id="content" className="main-content">
        <div className="layout-px-spacing">
          <div className="row invoice layout-top-spacing layout-spacing">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="doc-container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="invoice-container">
                      <div className="invoice-inbox">
                        <div id="ct" className="">
                          <div className="invoice-00001">
                            <div className="content-section">
                              <div className="inv--head-section inv--detail-section">
                                <div className="row" >

                                  <div className="col-sm-2 mt-2 text-center">
                                    <img className="company-logo" src={img1} alt="company" width="40" height="40" />
                                  </div>

                                  <div className="col-sm-3 mb-2 text-center">
                                    <table style={StyleProps1}>
                                      <tbody>

                                        <tr>
                                          <th scope="row" abbr="Guayaquil">Guayaquil:</th>
                                          <td>043906260 </td>

                                        </tr>
                                        <tr>
                                          <th scope="row" abbr="Quito">Quito:</th>
                                          <td>022800244 </td>

                                        </tr>
                                        <tr>
                                          <th scope="row" abbr="Sto. Domingo:">Sto. Domingo:</th>
                                          <td>0994190159 </td>

                                        </tr>
                                        <tr>
                                          <th scope="row" abbr="Machala:">Machala:</th>
                                          <td>0992798033 </td>

                                        </tr>
                                        <tr>
                                          <th scope="row" abbr="Ambato:">Ambato:</th>
                                          <td>0985796250 </td>

                                        </tr>
                                      </tbody>

                                    </table>
                                  </div>

                                  <div className="col-sm-2 mb-2 ">

                                    <div style={StyleProps1_1}>Operadora Logística del Ecuador Exactocarga</div>
                                    <div style={StyleProps1_1}>RUC:0993108766001</div>
                                    <div style={StyleProps1_1}>www.exactocarga.com</div>
                                  </div>

                                  <div className="col-sm2 mb-2 ml-4 mr-5 d-flex justify-content-center">
                                        <CodigoBarra 
                                          idGuiaProforma={mp?.id||0}
                                          width={1.4} 
                                          heigth={65}   
                                          />
                                  </div>
                                  <div className="col-sm-2 mb-2 text align-self-center">
                                    <table style={StyleProps3}>
                                      <tbody>
                                        <tr>
                                          <th scope="row">Fecha Emision:</th>
                                          <td className="text-center">{mp?.fechaEmision? new Date(mp?.fechaEmision).toLocaleString(): ""} </td>
                                        </tr>

                                        <tr>
                                          <th scope="row">Manifiesto:</th>
                                          <td className="text-center">{`${mp?.serie1}-${mp?.serie2}-${mp?.numeroDocumento}`} </td>
                                        </tr>

                                        <tr>
                                          <th scope="row">Estado:</th>
                                          {mp?.estado === LogisticaManifiestoProformaEstado.Pendiente ?
                                            <td className="text-center">Pendiente </td>
                                            : mp?.estado === LogisticaManifiestoProformaEstado.Anulado?
                                            <td className="text-center text-danger">Anulado </td>
                                            : mp?.estado === LogisticaManifiestoProformaEstado.Convertido?
                                            <td className="text-center text-success">Convertido</td>
                                            :<td className="text-center">??</td>

                                          }
                                        </tr>
                                        <tr>
                                          <th scope="row">id Manif:</th>
                                          <td className="text-center">{`${mp?.id}`} </td>
                                        </tr>

                                      </tbody>

                                    </table>

                                  </div>
                                </div>
                              </div>
                              <GuiaIndv manifiestosProforma={manifiestoDB.info} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      :
      <div id="content" className="main-content d-flex justify-content-center">
        {manifiestoDB.loading === true?
          <Loading/>
          :<span className="text-danger mt-5"> No se encontró este resumen de guias</span>
        }
        </div>
      

  );
};

export default ImprimirContent;
